import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import operationTypes from 'constants/operationTypes';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const CapitalVariationOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const isIncrease =
    data.operation?.operationType === operationTypes.CAPITAL_INCREASE ||
    data.operation?.operationType === operationTypes.CONSTITUTION;

  const valueLabel = isIncrease ? t('Premium') : t('Price');

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Partner')}</th>

        <th className="nk-tb-col text-right">{t('NrPart')}</th>

        <th className="nk-tb-col text-right">{t('From')}</th>

        <th className="nk-tb-col text-right">{t('To')}</th>

        <th className="nk-tb-col text-center">{t('Class')}</th>

        <th className="nk-tb-col text-right">{t('NomValue')}</th>

        <th className="nk-tb-col text-right">{valueLabel}</th>

        <th className="nk-tb-col text-right">{t('Total')}</th>
      </tr>
    </thead>
  );
};

export default CapitalVariationOperationTableHeader;
